export default {
  en: {
    CAMPAIGN_CREATE_FORM_NAME_LABEL: 'Campaign Name',
    CAMPAIGN_CREATE_FORM_NAME_TT: 'Your campaign name will be used to display information around the Ringba portal. Short campaign names work best.',
    CAMPAIGN_CREATE_FORM_NAME_PH: 'e.g. Facebook US Insurance',
    CAMPAIGN_CREATE_FORM_COUNTRY_LABEL: 'Country',
    CAMPAIGN_CREATE_FORM_COUNTRY_TT: 'Select the country of the phone numbers you would like to use in the campaign.',
    CAMPAIGN_CREATE_FORM_COUNTRY_DEFAULT: 'Select Country',
    CREATE_CAMPAIGN_FORM_TITLE: 'Create Campaign',
    CAMPAIGN_CREATE_FORM_DESCRIPTION: 'Please name your Campaign and select the country where you would like to accept phone calls.',
    CAMPAIGN_CREATE_SUPPORT_MESSAGE: 'You must contact Ringba Support to add numbers from this country.'
  }
};